module.exports = __webpack_public_path__ + "static/media/example-01.79d474c7.jpg";